module.exports = __webpack_public_path__ + "static/media/black.722ba79b.svg";